import { jsx as _jsx } from "react/jsx-runtime";
import { clsx } from 'clsx';
import { Controller, useFormContext } from 'react-hook-form';
import { useFormInputLayout, FormInputLayout, } from '../FormInputLayout/FormInputLayout';
import * as styles from './FormInputCheckboxGroup.module.scss';
import { BaseCheckbox } from '../FormInputCheckbox/BaseCheckbox';
const Name = 'FormInputCheckboxGroup';
const reduceValueToMap = (map, value) => {
    return {
        ...map,
        [value.name]: value.value ?? false,
    };
};
export const FormInputCheckboxGroup = props => {
    const { control } = useFormContext();
    const { className, dependentFields, disabled, hint, id, label, labelledBy, name, required, componentProps: { options = [], ...otherComponentProps }, } = useFormInputLayout(props);
    const fieldStyles = clsx(styles.container, props.className);
    if (!id)
        return null;
    const initialSelection = options.reduce(reduceValueToMap, {});
    return (_jsx(Controller, { control: control, name: name, rules: {
            deps: dependentFields,
        }, render: ({ field: { onChange, name, value = [] } }) => (_jsx(FormInputLayout, { className: className, "data-component": Name, disabled: disabled, fieldId: id, hint: hint, label: label, labelledBy: labelledBy, name: name, required: required, renderInput: state => {
                const { hintId, inputId, isValid, labelId, required } = state;
                const selectionMap = value.reduce(reduceValueToMap, initialSelection);
                const handleChange = (checked, optionName) => {
                    const updatedSelection = {
                        ...selectionMap,
                        [optionName]: checked,
                    };
                    const updatedValue = options.map((option) => {
                        return {
                            name: option.name,
                            value: updatedSelection[option.name] ?? false,
                        };
                    });
                    onChange(updatedValue);
                };
                return (_jsx("fieldset", { "aria-describedby": hintId, "aria-labelledby": labelId, "aria-required": required, className: fieldStyles, disabled: disabled, id: inputId, children: options.map((option) => {
                        const optionName = option.name;
                        return (_jsx(BaseCheckbox, { "aria-invalid": !isValid, "aria-disabled": disabled, label: option.label, name: name, onChange: ({ currentTarget: { checked } }) => {
                                handleChange(checked, optionName);
                            }, value: selectionMap[optionName], ...otherComponentProps }, optionName));
                    }) }));
            } })) }));
};
